<template>
	<JBox>
		<JBox class="s-mb-6">
			<JRadios :options="availableLocales" v-model="selectedLocale" />
		</JBox>
		<JBox v-for="(value, name) in internalLocalesObject[selectedLocale]" :key="name" class="s-mb-4">
			<CFormInput
				:label="name"
				componentName="JInputLongText"
				:rows="2"
				:name="name"
				class="s-mb-4"
				v-model="internalLocalesObject[selectedLocale][name]"
			/>
		</JBox>
	</JBox>
</template>

<script>
import transpileEditorScriptToVueObject from "../compilers/transpileEditorScriptToVueObject"
import provider from "@/dependencyInjections/provider"

export default {
	data() {
		return {
			internalLocalesObject: null, // extracted locales property from data of the component
			selectedLocale: "" // v-model for locales switcher
		}
	},

	computed: {
		availableLocales() {
			if (!this.internalLocalesObject) return []
			return Object.keys(this.internalLocalesObject).reduce((acc, key) => {
				acc.push({ name: key, value: key })
				return acc
			}, [])
		}
	},

	methods: {
		compilelInternalLocalesObjectToEditorScript() {
			// 1: Grab internalLocalesObject, convert it into a string
			// 2: Replace old "locales" in the original internalComponent.editorScript string with new locales string
			// 3: Patch internalComponent.editorScript
			// NOTE: There are possible problems with this approach, when converting to data string, if there is any functions, regex, it will fail
			// The best approach would probably be to replace data() as a string manipulation or convert editorScript to AST, do updates to data and convert back to JS string
			// Probalby AST and back to string is the best approach as we can use it for methods and other stuff

			console.log("TODO - Implement ast parser, traversing, updating, compiling back to string")
		}
	},

	watch: {
		"$store.state.uiEditor.selectedComponentId": {
			handler() {
				const component = this.$store.getters["uiEditor/selectedComponent"]
				const editorScript = component?.editorScript

				// NOTE: this is incorrect approach as we have to invoke data to actually get data object
				// This approach breaks when data is using some methods or more complicated things than data
				// For this kind of manipulation when we need to manipulate script string, we should do it via JavaScript AST traversing
				let vueObject = transpileEditorScriptToVueObject({ editorScript, version: component?.version?.version })
				vueObject = { ...vueObject, ...provider() } // HACK: append injections so that when data is using some injected things it will not fail
				const dataProperty = vueObject?.data ? vueObject.data() : {}

				// Set state
				this.internalLocalesObject = dataProperty?.locales ?? {}
				this.selectedLocale = this?.availableLocales?.[0]?.value // select first locale
			},
			immediate: true,
			deep: false
		}
	}
}
</script>
